import styled from 'styled-components'

const AuthenticationContainer = styled.div`
  display: flex;
  width: 900px;
  justify-content: space-between;
  margin: 30px auto;
`

export { AuthenticationContainer }
